import { useState, useContext } from "react"
import { AppContext } from "../data/store"
import Form from "./pay"
import History from "./hist"

const Sidebar = () => {
  const [mode, setMode] = useState("pay")
  const { user, setUser, setMessage } = useContext(AppContext)

  const walletAuth = async () => {
    if(window.ethereum) {
      try {
        const accounts = await window.ethereum.request({ method: "eth_requestAccounts" })

        setMessage('')
        setUser({ walletAddress: accounts[0], avatar: '' })
      } catch (error) {
        setMessage(error.message)
      }
    } else {
      setMessage('Please install MetaMask extension to use our webpage!')
    }
  }

  console.log(user)

  return (
    <div className="flex flex-col items-end gap-12 flex-1 overflow-y-auto p-6">
      <div className="flex flex-row gap-4 items-center px-2 lg:px-12">
        <button className="hover__button">
          <a target="_blank" rel="noreferrer" href="https://ethereum.org/en/">
            New to eth oddessy?
          </a>
        </button>
        { !user ? <button onClick = { walletAuth } className="hover__button">Connect MetaMask</button> : <img src = { user.avatar } className = "w-12 h-12 rounded-full" alt = "user__avatar" /> }
      </div>
      <div className="flex flex-row gap-6 lg:gap-12 items-center cursor-pointer text-xs lg:text-sm text-white px-6 lg:px-12">
        <p
          className={mode === "pay" ? "tabs__selected" : ""}
          onClick={() => setMode("pay")}
        >
          Payment
        </p>
        <p
          className={mode === "hist" ? "tabs__selected" : ""}
          onClick={() => setMode("hist")}
        >
          History
        </p>
      </div>
      <div className="w-full">{mode === "pay" ? <Form /> : <History />}</div>
    </div>
  )
}

export default Sidebar